/**
 * Compact status pill — renders the connection state in a minimal form.
 */

import React from "react";
import { motion } from "framer-motion";
import { tokens } from "./styles";

const COPY = {
  idle: { label: "Standing by", color: tokens.ink[300] },
  connecting: { label: "Connecting...", color: tokens.accent.cyan },
  connected: { label: "Listening", color: tokens.accent.cyan },
  disconnecting: { label: "Wrapping up...", color: tokens.ink[300] },
  error: { label: "Voice error", color: "#FCA5A5" },
};

export function StatusIndicator({ status, isAssistantSpeaking }) {
  const entry = COPY[status] || COPY.idle;
  const label = isAssistantSpeaking && status === "connected" ? "Noki speaking" : entry.label;
  const color =
    isAssistantSpeaking && status === "connected" ? tokens.accent.violet : entry.color;
  const pulse = status === "connected" || status === "connecting";

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        padding: "4px 10px",
        borderRadius: 999,
        background: tokens.surface.panelLight,
        border: `1px solid ${tokens.surface.border}`,
        fontSize: 11,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: tokens.ink[200],
      }}
    >
      <span style={{ position: "relative", width: 7, height: 7 }}>
        <motion.span
          aria-hidden="true"
          animate={
            pulse
              ? { scale: [1, 1.7, 1], opacity: [0.45, 0, 0.45] }
              : { scale: 1, opacity: 0.45 }
          }
          transition={
            pulse
              ? { duration: 1.6, ease: "easeInOut", repeat: Infinity }
              : { duration: 0.2 }
          }
          style={{
            position: "absolute",
            inset: 0,
            borderRadius: "50%",
            background: color,
          }}
        />
        <span
          style={{
            position: "absolute",
            inset: 0,
            borderRadius: "50%",
            background: color,
          }}
        />
      </span>
      <span style={{ color, fontWeight: 600 }}>{label}</span>
    </span>
  );
}
